export class QuotesEnvironment {
  public static getName = () => 'benzinga-quotes';
  public static getEnvironment = (env: Record<string, string>) => ({
    analysisUrl: new URL(env.analysisUrl ?? 'https://www.benzinga.com/'),

    bullSayBearSayToken: env.bullSayBearSayToken ?? 'bcb21f0e5c2ec60fc1fa834444cf04665e04175a6e860cd5d27c9f25e31808d1',
    bullSayBearSayUrl: new URL(env.bullSayBearSayUrl ?? 'https://api.benzinga.com/'),

    delayedQuoteKey: env.delayedQuoteKey ?? '81DC3A5A39D6D1A9D26FA6DF35A34',
    delayedQuoteUrl: new URL(env.delayedQuoteUrl ?? 'https://data-api-next.benzinga.com/rest/'),

    logosKey: env.logosKey ?? '539775a6a04740fc9f7530f102afa105',
    logosUrl: new URL(env.logosUrl ?? 'https://api.benzinga.com/api/'),

    nextApiUrl: new URL(env.nextApiUrl ?? 'https://www.benzinga.com/api-next/'),

    scheduleKey: env.scheduleKey ?? '81DC3A5A39D6D1A9D26FA6DF35A34',
    scheduleUrl: new URL(env.scheduleUrl ?? 'https://data-api-next.benzinga.com/rest/'),

    shortInterestKey: env.shortInterestKey ?? '2RiuR92vjytxS8r93w3c8WTpGSd3y9Gk',
    shortInterestUrl: new URL(env.shortInterestUrl ?? 'https://data-api.benzinga.com/'),

    socketUrl: new URL(env.socketUrl ?? 'wss://pro-quote-v2.benzinga.com/quote/'),

    symbolsKey: env.symbolsKey ?? '54b595f497164e0499409ca93342e394',
    symbolsUrl: new URL(env.symbolsUrl ?? 'https://data-api-pro.benzinga.com/rest/'),

    tickersKey: env.tickersKey ?? '81DC3A5A39D6D1A9D26FA6DF35A34',
    tickersUrl: new URL(env.tickersUrl ?? 'https://data-api-next.benzinga.com/rest/'),
  });
}
